var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCardOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.33 4H3.67C2.747 4 2 4.768 2 5.714v12.572C2 19.232 2.747 20 3.67 20h16.66c.924 0 1.67-.768 1.67-1.714V5.714C22 4.768 21.253 4 20.33 4zM3.878 5.714h16.244c.114 0 .208.097.208.215v1.5H3.67v-1.5c0-.118.094-.215.208-.215zm16.244 12.572H3.878a.212.212 0 01-.208-.215V12h16.66v6.071a.212.212 0 01-.208.215zM8.667 14.714v1.429a.424.424 0 01-.417.428h-2.5a.424.424 0 01-.417-.428v-1.429c0-.235.188-.428.417-.428h2.5c.23 0 .417.193.417.428zm6.666 0v1.429a.424.424 0 01-.416.428h-4.723a.424.424 0 01-.416-.428v-1.429c0-.235.187-.428.416-.428h4.723c.229 0 .416.193.416.428z",
    fill: "#777"
  })));
}

export default SvgCreditCardOutline;